// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- 3rd Party
import { HubConnection } from '@microsoft/signalr';
import * as signalR from '@microsoft/signalr';
import { User as OidcUser } from 'oidc-client';

// --- HS Code
import { OidcService } from '../account/oidc.service';
import { environment } from '../../../../environments/environment';
import { UserNotificationBaseService } from './user-notification-base.service';
import { NotificationModel } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export class UserNotificationService extends UserNotificationBaseService {
  private _hubConnection: HubConnection | undefined;
  private _isConnected: boolean;

  constructor(private oidcService: OidcService) {
    super();
  }

  connect(): void {
    if (!this._isConnected)
    {
      this.oidcService.identity$.subscribe(user => {
        if (user != null) {
          this._initHub(user);
        }
      });
      this._isConnected = true;
    }
  }

  private _initHub(user: OidcUser) {
    const token = user.access_token;

    const url = environment.apiConfig.baseUrl + environment.apiConfig.hubApi;

    this._hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(`${url}`, { accessTokenFactory: () => token })
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this._hubConnection.on('Notify', (notification: NotificationModel) => {
      console.log('Notification received');
      this._processNotification(notification);
    });

    this._hubConnection.start().catch(err => console.error(err.toString()));
  }

  signOut(): void {
    this._hubConnection.stop().catch(err => console.error(err.toString()));
  }

  view(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    notifications.forEach((notificationItem, index: number) => {
      if (notificationItem.id === notification.id) {
        notificationItem.isRead = true;
      }
    });

    this._notifications$.next(notifications);
  }
  remove(notification: NotificationModel): void {
    const notifications = this._notifications$.value;
    const notificationIndex = notifications.findIndex(x => x.id === notification.id);
    if (typeof notificationIndex !== 'undefined') {
      notifications.splice(notificationIndex, 1);
    }
    this._notificationList = notifications;
    this._notifications$.next(notifications);
  }
}
